import React, { createContext, useContext, useState } from "react";

//create context
const LocalRoutesContext = createContext();

//create the provider
export const LocalRoutesProvider = ({ children }) => {
  //lazy loading + code splitting
  const Home = React.lazy(() => import(`../pages/Home`));
  const Category = React.lazy(() => import(`../pages/Category`));
  const Photos = React.lazy(() => import(`../pages/Photos`));
  const AboutMe = React.lazy(() => import(`../pages/AboutMe`));

  const [localRoutes, setLocalRoutes] = useState({
    routes: [
      {
        name: "home",
        path: "/",
        subPath: [],
        element: <Home title={process.env.REACT_APP_APP_NAME} />,
        headerVisible: false,
      },
      {
        name: "home",
        path: "/home",
        subPath: [],
        element: <Home title={process.env.REACT_APP_APP_NAME} />,
        headerVisible: false,
      },
      {
        name: "categorie",
        path: "/category/all",
        element: <Category title={`${process.env.REACT_APP_APP_NAME}`} />,
        subPath: [
          {
            name: "natura",
            path: `/${process.env.REACT_APP_ROUTE_PHOTO_NATURA}&subtitle=Tutto_sul_mondo_della_natura`,
            element: "",
          },
          {
            name: "paesaggi",
            path: `/${process.env.REACT_APP_ROUTE_PHOTO_PAESAGGI}&subtitle=lascia_scorrere_lo_sguardo`,
            element: "",
          },
          {
            name: "street & persone",
            path: `/${process.env.REACT_APP_ROUTE_PHOTO_PERSONE}&subtitle=fatti_raccontare_una_storia`,
            element: "",
          },
          {
            name: "varie",
            path: `/${process.env.REACT_APP_ROUTE_PHOTO_VARIE}&subtitle=in_ogni_dettaglio`,
            element: "",
          },
        ],
      },
      {
        name: "category precise",
        path: "/photos/category/:category",
        element: <Category title={`${process.env.REACT_APP_APP_NAME}`} />,
        headerVisible: false,
      },
      {
        name: "photo",
        path: "/photos/:params",
        subPath: [],
        element: <Photos title={`${process.env.REACT_APP_APP_NAME}`} />,
        headerVisible: false,
      },
      {
        name: "about me",
        path: "/about-me",
        subPath: [],
        element: <AboutMe title={`${process.env.REACT_APP_APP_NAME}`} />,
      },
    ],
  });

  return (
    <LocalRoutesContext.Provider value={{ localRoutes, setLocalRoutes }}>
      {children}
    </LocalRoutesContext.Provider>
  );
};

export const useLocalRoutes = () => useContext(LocalRoutesContext);
